(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-blog"] && !Shopify.designMode) return;
  try {
    
(()=>{
const RM=matchMedia('(prefers-reduced-motion:reduce)');
const init=e=>{
  if(e._i)return;
  const t=e.querySelector('.hb__track');
  if(!t)return;
  e._i=1;
  const p=e.querySelector('.hb__prev'),n=e.querySelector('.hb__next'),d=e.querySelector('.hb__dots');
  const loop=!!e.dataset.loop,auto=+e.dataset.auto||0;
  let step=0,max=0,count=0,cur=-1,raf=0,dots=[],hold=false,seen=true,idle=0;

  const go=x=>t.scrollTo({left:x,behavior:RM.matches?'auto':'smooth'});
  const nx=()=>t.scrollLeft>=max?(loop&&go(0)):go(t.scrollLeft+step);
  const pv=()=>t.scrollLeft<=2?(loop&&go(max)):go(t.scrollLeft-step);

  // layout reads happen here only (init + resize), never in the scroll path
  const measure=()=>{
    const f=t.firstElementChild;
    if(!f)return;
    step=f.offsetWidth+(parseFloat(getComputedStyle(t).columnGap)||0);
    max=t.scrollWidth-t.clientWidth-2;
    const c=step>0?Math.max(0,Math.round(max/step))+1:1;
    if(d&&c!==count){
      const fr=document.createDocumentFragment();
      dots=[];
      for(let i=0;i<c;i++){
        const b=document.createElement('button');
        b.type='button';b.dataset.i=i;b.setAttribute('aria-label','Slide '+(i+1));
        fr.appendChild(b);dots.push(b);
      }
      d.replaceChildren(fr);
      cur=-1;
    }
    count=c;
    e.classList.toggle('is-static',max<=0);
  };

  // scroll path: one scrollLeft read, writes only on change
  const update=()=>{
    raf=0;
    const s=t.scrollLeft;
    const last=count-1;
    const i=s>=max||step<=0?last:Math.min(last,Math.round(s/step));
    if(i!==cur){
      if(dots[cur])dots[cur].classList.remove('on');
      if(dots[i])dots[i].classList.add('on');
      cur=i;
    }
    const dp=!loop&&s<=2,dn=!loop&&s>=max;
    if(p&&p.disabled!==dp)p.disabled=dp;
    if(n&&n.disabled!==dn)n.disabled=dn;
  };

  if(p)p.addEventListener('click',pv);
  if(n)n.addEventListener('click',nx);
  if(d)d.addEventListener('click',ev=>{const b=ev.target.closest('button');if(b)go(+b.dataset.i*step)});
  t.addEventListener('scroll',()=>{raf||(raf=requestAnimationFrame(update))},{passive:true});

  const ro=new ResizeObserver(()=>{measure();update()});
  ro.observe(t);
  if(t.firstElementChild)ro.observe(t.firstElementChild);

  if(auto&&!RM.matches){
    if('IntersectionObserver' in window)new IntersectionObserver(r=>{seen=r[0].isIntersecting},{threshold:.1}).observe(e);
    const z=setInterval(()=>{
      if(!e.isConnected)return clearInterval(z);
      if(seen&&!hold&&!document.hidden&&Date.now()-idle>=auto)nx();
    },auto);
    ['mouseenter','focusin','touchstart'].forEach(v=>e.addEventListener(v,()=>{hold=true},{passive:true}));
    ['mouseleave','focusout','touchend'].forEach(v=>e.addEventListener(v,()=>{hold=false;idle=Date.now()},{passive:true}));
  }
};
const run=()=>document.querySelectorAll('.hb').forEach(init);
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',run):run();
document.addEventListener('shopify:section:load',ev=>ev.target.querySelectorAll('.hb').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
